<template>
    <div id="button-container" class="row">
        <div class="col-xs-12 text-center">
            <back-to-work-button class="btn btn-default" v-if="showBackToWork" />
            <button type="button" class="btn btn-primary" @click="clickTemplate" style="margin-left: 5px;">{{ $t('toolbar.start_from_scratch') }}</button>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { debounce } from 'lodash';
import BackToWorkButton from './BackToWorkButton.vue';

const emptyTemplate = {
  id: 0,
  name: ''
};

export default {
  name: 'ButtonContainer',
  components: {
    BackToWorkButton
  },
  computed: {
    ...mapGetters([
      'showBackToWork'
    ])
  },
  methods: {
    ...mapActions([
      'retrieveTemplate'
    ])
  },
  created: function() {
    const that = this;
    this.clickTemplate = debounce(function() {
      if (that.showBackToWork) {
        that.$emit('conflict', emptyTemplate);
      } else {
        that.retrieveTemplate(emptyTemplate);
      }
    }, 500);
  }
};
</script>

<style scoped>
#button-container {
    margin-bottom: 20px;
    margin-right: 20px;
}
</style>
